export default "__VITE_ASSET__DHm07bRK__"